'use strict'

import 'jquery'

require('./setup')
require('./cookies')
require('./layout')
require('./scroll-smoother')

require('./elements/animation-line')
require('./elements/animate-image-scale')
require('./elements/animate-divider')
require('./elements/sticky-image')
require('./elements/video-modal')
require('./elements/animate-hr')

require('./blocks/hero')
require('./blocks/all-why-us')
require('./blocks/all-services')
require('./blocks/faq')
require('./blocks/text-slider')
require('./blocks/timeline-text-slider')
require('./blocks/timeline-years')
require('./blocks/about-us')
require('./blocks/404')
require('./blocks/footer')

require('./utils/file-upload')

require('./blocks/gallery')

require('./rive')

require('./menu')

require('./form')

require('./news')
require('./news-modal')
